import { useEffect, useState } from 'react'
import { SettingsIcon } from '@/design-system/icons'
import { useCompanion } from '@/hooks/useCompanion'
import { getCompanionGreeting, setCompanionEnabled, type CompanionAnswer } from '@/lib/companion'
import { CompanionEvidence } from '@/components/CompanionEvidence'

export function CompanionGreeting() {
  const { scope, enabled, actorName } = useCompanion()
  const [result, setResult] = useState<{ key: string; answer: CompanionAnswer | null } | null>(null)
  const [error, setError] = useState('')
  const key = JSON.stringify([scope, actorName, enabled])
  useEffect(() => {
    let active = true
    if (enabled && scope) {
      void getCompanionGreeting(scope, actorName).then((answer) => { if (active) setResult({ key, answer }) })
    }
    return () => { active = false }
  }, [scope, enabled, actorName, key])
  if (!enabled || !scope) return null
  const answer = result?.key === key ? result.answer : null
  return (
    <section aria-label="Wren companion" className="text-caption text-text-secondary">
      <div className="flex items-center gap-2">
        <p className="flex-1" style={{ fontVariant: 'small-caps' }}>{answer?.text ?? (result?.key === key ? 'Verified context is unavailable right now.' : 'Wren is looking for verified context.')}</p>
        <button type="button" aria-label="Turn off companion mode" title="Turn off companion mode"
          className="min-h-11 min-w-11 flex items-center justify-center rounded-full hover:bg-bg-elevated"
          onClick={() => { if (!setCompanionEnabled(scope.userId, scope.familyId, false)) setError('Could not save this preference; turn off browser storage restrictions and retry.') }}>
          <SettingsIcon size={16} />
        </button>
      </div>
      {answer && <CompanionEvidence answer={answer} compact />}
      {error && <p role="alert">{error}</p>}
    </section>
  )
}
